import makeTable from "./makeTable";

export enum ColumnId {
	Name = "name",
	DriversAmount = "driversAmount",
	Aliases = "aliases",
	Company = "company",
	TaxiService = "taxiService",
}

export const translationTablePath = "orderPageWidgets.parking.parkingTable.";
export const translationTablePath2 = "orderPageWidgets.executors.modelTable.";

export const allColumns: ColumnId[] = Object.values(ColumnId);

export const defaultColumns: ColumnId[] = allColumns;

const orderWidgetParkings = makeTable({
	allIds: allColumns,
	i18tPath: (id) => {
		switch (id) {
			case ColumnId.Name:
				return `${translationTablePath}str150`;
			case ColumnId.DriversAmount:
				return `${translationTablePath}str151`;
			case ColumnId.Aliases:
				return `${translationTablePath}str152`;
			case ColumnId.Company:
				return `${translationTablePath2}str154`;
			case ColumnId.TaxiService:
				return `${translationTablePath2}str155`;
			default:
				return `${translationTablePath}${id}`;
		}
	},
	defaultIds: defaultColumns,
	initialSortMethod: {
		column: ColumnId.Name,
		type: "asc",
	},
	initialWidths: {
		[ColumnId.Name]: 190,
		[ColumnId.DriversAmount]: 48,
		[ColumnId.Aliases]: 200,
		[ColumnId.Company]: 130,
		[ColumnId.TaxiService]: 80,
	},
	initialResizable: {
		[ColumnId.Name]: true,
		[ColumnId.DriversAmount]: true,
		[ColumnId.Aliases]: true,
		[ColumnId.Company]: true,
		[ColumnId.TaxiService]: true,
	},
	initialSortable: {
		[ColumnId.Name]: true,
		[ColumnId.DriversAmount]: true,
		[ColumnId.Aliases]: true,
		[ColumnId.Company]: true,
		[ColumnId.TaxiService]: true,
	},
});

export default orderWidgetParkings;
